import { on } from 'delegated-events'

const fn = {
  init: () => {
    on('click', '[data-full-modal]', fn.handleModalOpen)
    on('click', '.full-modal-close', fn.handleModalClose)
  },

  handleModalOpen: (e) => {
    const target = e.target.closest('[data-full-modal]').dataset.fullModal
    const el = document.querySelector(`.full-modal[data-modal="${target}"]`)

    if (el) {
      el.classList.remove('opacity-0')
      el.classList.remove('pointer-events-none')
      document.documentElement.classList.add('overflow-hidden')
    }
  },

  handleModalClose: (e) => {
    const modal = e.target.closest('.full-modal')

    modal.classList.add('opacity-0', 'pointer-events-none')
    document.documentElement.classList.remove('overflow-hidden')
  },
}

export default {
  can: () => true,
  run: fn.init,
}
